import { Toast } from "primereact/toast";
import React, { useRef, useEffect } from "react";
import ConfirmDocument from "../../components/ConfirmDocument/ConfirmDocument";
import Footer from "../../components/Footer/Footer";
import Loading from "../../components/Loading/Loading";
import Navbar from "../../components/Navbar/Navbar";
import SEO from "../../components/SEO/SEO";
import SearchProducts from "../../components/SearchProducts/SearchProducts";
import Wrapper from "../../components/Wrapper/Wrapper";
import useSearchProducts from "../../hooks/useSearchProducts";
import showErrorToast from "../../utilities/Toast/showErrorToast";
import "./ProductInfo.css";
import ProductSection from "./components/ProductSection/ProductSection";
import useProduct from "./hooks/useProduct";
import AdvancedFilterModal from "../../components/SearchProducts/Components/AdvancedFilterModal/AdvancedFilterModal";
import { useToggle } from "../../hooks/useToggle";
import { useToastContext } from "../../contexts/ToastContext/ToastContext";
import useGetStoresNames from "../../hooks/useGetStoresNames";
import GetShareService from "../../service/ShareService";

import SectionProducts from "../Shop/components/SectionProducts/SectionProducts";
import useShopSections from "../Shop/hooks/useShopSections";
import LandingFooter from "../Landing/components/LandingFooter/LandingFooter";
import LandingCopyright from "../Landing/components/LandingCopyright/LandingCopyright";

const ProductInfo = ({ id }) => {
  const toast = useRef(null);

  const { shopSections, isLoading } = useShopSections({ onError: showErrorToast(toast.current) });

  const getShareService = new GetShareService();

  const {
    productInfo,
    loadingProductInfo,
    currency,
    currentAttribute1Value,
    currentAttribute2Value,
    currentVariation,
    attribute1Values,
    attribute2Values,
    productQty,
    isFreeExtracoin,
    setProductQty,
    checkAndSetCurrentAttribute1Value,
    checkAndSetCurrentAttribute2Value,
    setProductPercentExtracoin,
  } = useProduct({
    id,
    onError: showErrorToast(toast.current),
    OnErrorAmountOrders: showErrorToast(toast.current),
    onErrorPlan: showErrorToast(toast.current),
  });

  useEffect(() => {
    (async () => {
      const params = new URLSearchParams(window.location.search);
      const shareParam = params.get("share");

      if (
        shareParam &&
        localStorage.getItem("__extraconomy_username") &&
        productInfo?.data?.product?.user?.username &&
        localStorage.getItem("__extraconomy_username") !==
          productInfo?.data?.product?.user?.username
      ) {
        try {
          const res = await getShareService.postShareClick(
            productInfo?.data?.product.id,
            shareParam
          );
          window.prerenderReady = true;
          return res.result.clicked;
        } catch (error) {
          return null;
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productInfo?.data?.product?.user?.username]);

  return (
    <>
      {/* <Navbar hiddenLeftSideBar={true} /> */}
      <Toast ref={toast} />

      <div className="content-grid bg-white">
        <Wrapper>
          {loadingProductInfo && (
            <Loading
              classNameContainer="flex justify-content-center align-items-center"
              classNameIcon="text-6xl"
              stylesContainer={{ minHeight: "40vh" }}
            />
          )}
          {!loadingProductInfo && productInfo && (
            <>
              <SEO
                title={productInfo.data.product.title}
                description={productInfo.data.product.title}
                content={productInfo.data.product.description}
                url={`https://extraconomy.com/product?id=${productInfo.data.product.id}`}
                image={`https://res.cloudinary.com/dwpu3xryx/image/upload/c_fill,h_600,w_600/${productInfo.data.product.imageid1}?_a=AJAH1WI0.png`}
                alt={productInfo.data.product.title}
              />

              <ProductSection
                productInfo={productInfo}
                toast={toast}
                currency={currency}
                currentAttribute1Value={currentAttribute1Value}
                currentAttribute2Value={currentAttribute2Value}
                currentVariation={currentVariation}
                attribute1Values={attribute1Values}
                attribute2Values={attribute2Values}
                checkAndSetCurrentAttribute1Value={checkAndSetCurrentAttribute1Value}
                checkAndSetCurrentAttribute2Value={checkAndSetCurrentAttribute2Value}
                productQty={productQty}
                setProductQty={setProductQty}
                isFreeExtracoin={isFreeExtracoin}
                setProductPercentExtracoin={setProductPercentExtracoin}
              />
            </>
          )}
        </Wrapper>
        <LandingFooter />
        <LandingCopyright />
        <section
          className="md:py-5 full-width"
          style={{ backgroundColor: "#FFFFFF", color: "#7A869A", borderTop: "1px solid #E0E7FF" }}
        >
          <div className="grid gap-3 m-0">
            <div className="col-12 md:col text-center md:text-left">
              <div className="text-sm font-regular">EXTRACONOMY GLOBAL srl</div>
              <div className="text-sm font-regular">Via Nomentana, 1018 - 00137 Roma (IT)</div>
            </div>
            <div className="col-12 md:col text-center md:text-left">
              <div className="text-sm font-regular">P. Iva e C.F. 16948681008 | REA 1686351</div>
            </div>
            <div className="col-12 md:col text-center md:text-right">
              <div className="text-sm font-regular">Privacy Policy</div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ProductInfo;
